import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { QuiztimeApiService } from './quiztime-api.service';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {
  private quiztimeApi = inject(QuiztimeApiService);

  private readonly allowedImageTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif'
  ];

  validateImageType(file: File): { valid: boolean; message: string } {
    if (!file) {
      return { valid: false, message: 'No file provided' };
    }

    if (!this.allowedImageTypes.includes(file.type)) {
      return {
        valid: false,
        message: `Invalid image format. Allowed formats are: ${this.allowedImageTypes
          .map(type => type.replace('image/', ''))
          .join(', ')}`
      };
    }

    return { valid: true, message: 'Valid image type' };
  }

  /**
   * Uploads an image for a specific quiz
   * @param quizGuid The GUID of the quiz to upload the image for
   * @param file The file to upload
   * @param isBanner Whether this is a banner image (defaults to false)
   * @returns An observable with the response containing the image URL
   */
  uploadImage(quizGuid: string, file: File, isBanner: boolean = false): Observable<{ image_url: string }> {
    const validation = this.validateImageType(file);

    if (!validation.valid) {
      return throwError(() => new Error(validation.message));
    }

    return this.quiztimeApi.uploadMedia(quizGuid, file, isBanner);
  }
}
